import useId from '../utils/useId';
import * as React from 'react';
export const jiraSvg = React.forwardRef(function jiraSvgInner(props, ref) {
  const baseId = useId();
  const id_0 = baseId + '_0';
  const id_1 = baseId + '_1';
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F5F6F8',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#2684FF',
      d: 'M24.171 7h-9.628a4.34 4.34 0 0 0 4.342 4.343h1.772v1.714A4.34 4.34 0 0 0 25 17.4V7.829A.83.83 0 0 0 24.17 7Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: `url(#bi_jira__a_${id_0})`,
      d: 'M19.4 11.8H9.77a4.34 4.34 0 0 0 4.343 4.343h1.772v1.714c0 2.4 1.943 4.343 4.343 4.343v-9.571a.83.83 0 0 0-.83-.829Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: `url(#bi_jira__b_${id_1})`,
      d: 'M14.629 16.6H5a4.34 4.34 0 0 0 4.343 4.343h1.771v1.714c0 2.4 1.943 4.343 4.343 4.343v-9.571a.83.83 0 0 0-.828-.829Z',
    }),
    /*#__PURE__*/ React.createElement(
      'defs',
      null,
      /*#__PURE__*/ React.createElement(
        'linearGradient',
        {
          id: `bi_jira__a_${id_0}`,
          x1: 20.029,
          x2: 15.932,
          y1: 11.81,
          y2: 16.035,
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.176,
          stopColor: '#0052CC',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#2684FF',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'linearGradient',
        {
          id: `bi_jira__b_${id_1}`,
          x1: 15.534,
          x2: 10.797,
          y1: 16.636,
          y2: 21.245,
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.176,
          stopColor: '#0052CC',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#2684FF',
        }),
      ),
    ),
  );
});
jiraSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var jira = {
  category: 'brand',
  colorable: false,
  name: 'jira',
  svg: jiraSvg,
};
